// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "app.prod-" + {"src_views_NewspaperPage_index_ts":"68f2f707543dbc2c5a06","src_views_NewspaperDetail_index_ts":"5dd51b6de7435dbba5e0","src_components_Ads_SidebarAdv_tsx":"bbcda2214ce3baaca680","src_components_Ads_NewspaperGridAd_tsx":"7beb34a659000c470cb0"}[chunkId] + ".css";
};